import './styles.scss';
import { useContext } from 'react'
import { LanguageContext, localize } from '../Localization'

export default function Intro(props) {
  const language = useContext(LanguageContext)
  return (
    <div className='Footer'>
      <div className='row'>
        <span>
          {localize(language, 'footer', 'footer')}{' '}
          <a href='https://www.pitchinteractive.com' target='_blank' rel='noopener noreferrer'>Pitch Interactive, Inc.</a>
        </span>
      </div>
    </div>
  );
}
